import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import OtpInput from "react-otp-input";
import headerLogo from "../../Dashboard/img/header-logo.svg";
import smsConfirmationIcon from "../../Dashboard/img/sms-confirmation-icon.svg";
import commentAltLines from "../../Registration/img/comment-alt-lines.svg";
import AuthHeader from "../AuthHeader/AuthHeader";
import TimerCountdown from "../TimerCountdown/TimerCountdown";
import { request } from "../../../config";

import "./OTP.scss";
import { Link } from "@mui/material";

const OTP = ({ translate, updateAppState }) => {
  const [OTPCode, setOTPCode] = useState();
  const [errMessage, setErrMessage] = useState();
  const [verifyToken, setVerifyToken] = useState();
  const [disabled, setDisabled] = useState(true);

  let initialMinute = 3,
    initialSeconds = 0,
    numInputs = 6;

  let history = useHistory();
  const { state } = useLocation();

  const handleOTP = (otp) => setOTPCode(otp);

  const sendOtpCode = () => {
    updateAppState("isLoadingTransparentBackground", true);

    let requestBody = {
      mobile: state.phoneNumber,
      token: state.token,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
    };

    fetch(request("register/simaRegisterSendOtp", requestBody))
      .then((res) => res.json())
      .then(
        (sendOtpCodeRequestResponse) => {
          if (sendOtpCodeRequestResponse.status.statusCode !== 1) {
            updateAppState("isLoadingTransparentBackground", false);
            setErrMessage(
              translate(sendOtpCodeRequestResponse.status.statusCode)
            );
            setDisabled(true);
          } else {
            setVerifyToken(sendOtpCodeRequestResponse.verifyToken);
            updateAppState("isLoadingTransparentBackground", false);
            setDisabled(false);
          }
        },
        (error) => {
          history.push("/technical-break");
        }
      );
  };

  const verifyOtpCode = (e) => {
    e.preventDefault();

    updateAppState("isLoadingTransparentBackground", true);
    setErrMessage("");

    let requestBody = {
      password: state.password,
      repeatPassword: state.repeatPassword,
      confirmCode: OTPCode,
      token: state.token,
      verifyToken: verifyToken,
      lang: localStorage.getItem("i18nextLng").toUpperCase(),
    };

    fetch(request("register/simaRegisterVerifyOtp", requestBody))
      .then((res) => res.json())
      .then(
        (verifyOtpCodeRequestResponse) => {
          if (verifyOtpCodeRequestResponse.status.statusCode !== 1) {
            updateAppState("isLoadingTransparentBackground", false);
            setErrMessage(
              translate(verifyOtpCodeRequestResponse.status.statusCode)
            );
          } else {
            updateAppState("isLoadingTransparentBackground", false);
            history.push("/sign-up/not-a-bank-customer", {
              success: true,
            });
          }
        },
        (error) => {
          history.push("/technical-break");
        }
      );
  };

  useEffect(() => {
    if (state === undefined) history.push("/sign-up/not-a-bank-customer");
    else sendOtpCode();
  }, []);

  return (
    <div className="registration">
      <Link to="/">
        <img src={headerLogo} className="registration-logo" alt="headerLogo" />
      </Link>
      <form
        className="registration-container registration-container--top-border"
        onSubmit={verifyOtpCode}
      >
        <h2 className="registration-container-title">
          {translate("sms verification")}
        </h2>
        <p className="registration-container-description">
          {translate("enter the 6-digit confirmation code sent to your phone")}
        </p>
        <img
          src={smsConfirmationIcon}
          className="registration-container-icon"
          alt="smsConfirmationIcon"
        />
        <div className="registration-container-sms-confirmation justify-content-center">
          <OtpInput
            className="ibank-otp__body"
            value={OTPCode}
            onChange={handleOTP}
            shouldAutoFocus={true}
            {...{ initialMinute, initialSeconds, numInputs }}
          />
        </div>
        {/* <div className="registration-container-validation-feedback">
                                {feedbackMessage ? <p className="registration-container-validation-feedback-message">{t('the code you entered is incorrect')}</p> : null}
                            </div> */}
        <div className="registration-container-validation-feedback">
          {errMessage ? (
            <p className="registration-container-validation-feedback-message">
              {errMessage}
            </p>
          ) : null}
        </div>
        <div className="registration-container-resend">
          <div className="registration-container-resend-container w-100">
            {/* <div className="registration-container-resend-container-icon">
              <img
                src={commentAltLines}
                className="registration-container-resend-container-icon-img"
                alt="commentAltLines"
              />
            </div> */}
            <TimerCountdown
              resendTitle={translate("resend the code")}
              {...{
                initialMinute,
                initialSeconds,
                sendOtpCode,
                setErrMessage,
              }}
            />
            {/* <button type="button" className="registration-container-resend-container-button" onClick={this.sendOtpCode}>{t('resend the code')}</button> */}
          </div>
          {/* <span className="registration-container-resend-timer">{timer}</span> */}
        </div>
        <div className="registration-container-footer">
          {/* <button type="button" className="registration-container-footer-button registration-container-footer-button--left" onClick={this.backCheckCustomer}>{t('back')}</button> */}

          <button
            className="header-sign-section-container-form-button"
            disabled={OTPCode?.length !== numInputs || disabled}
          >
            {translate("continue")}
          </button>
          {/* <button className="registration-container-footer-button registration-container-footer-button--right" disabled={isDisabled} onClick={this.verifyOtpCode}>{t('next')}</button> */}
        </div>
      </form>
    </div>
    // <section className="ibank-otp header-sign-section">
    //   <div className="header-sign-section-container">
    //     <AuthHeader
    //       title={translate("Enter the one-time code")}
    //       desc={[
    //         translate("enter the 6-digit confirmation code sent to your phone"),
    //       ]}
    //     />
    //     <form onSubmit={verifyOtpCode}>
    //       <OtpInput
    //         className="ibank-otp__body"
    //         value={OTPCode}
    //         onChange={handleOTP}
    //         shouldAutoFocus={true}
    //         {...{ initialMinute, initialSeconds, numInputs }}
    //       />
    //       <TimerCountdown
    //         resendTitle={translate("resend the code")}
    //         {...{
    //           initialMinute,
    //           initialSeconds,
    //           sendOtpCode,
    //           setErrMessage,
    //         }}
    //       />
    //       <div className="registration-container-validation-feedback">
    //         {errMessage ? (
    //           <p className="registration-container-validation-feedback-message">
    //             {errMessage}
    //           </p>
    //         ) : null}
    //       </div>
    //       <button
    //         className="header-sign-section-container-form-button"
    //         disabled={OTPCode?.length !== numInputs}
    //       >
    //         {translate("continue")}
    //       </button>
    //     </form>
    //   </div>
    // </section>
  );
};

export default OTP;
